import { ItiBaseDto } from '@/iti-core-vue';

export class Values extends ItiBaseDto {
    public id !: number;
    public value !: string;
    public fieldId !: number;
    public fieldCode !: string;
    public fieldDescription !:string;
}